import {Injectable} from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {from, lastValueFrom, Observable, switchMap, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {SessionQuery} from "../stores/session/session.query";
import {AuthService} from "../../landing/login/login.service";
import {MatDialog} from "@angular/material/dialog";
import {environment} from "../../../environments/environment";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  private readonly SKIP_ROUTES = [
    'auth/exchange',
    'auth/refresh',
    'auth/logout',
  ];

  constructor(
      private _session: SessionQuery,
      private _dialog: MatDialog,
      private _auth: AuthService
  ) {}


  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Le rotte auth non devono avere Bearer e non devono triggerare refresh
    if (this.isSkipRoute(request.url)) {
      return next.handle(request);
    }

    return from(this.addToken(request, next));
  }

  async addToken(request: HttpRequest<any>, next: HttpHandler): Promise<HttpEvent<any>> {
    const headers: any = {};
    request.headers.keys().forEach(k => headers[k] = request.headers.get(k));
    const token = request.headers.get('AuthType') === 'api' ? environment.apiKey : this._session.jwt;
    if (token) {
      request = request.clone({
        setHeaders: {Authorization: `Bearer ${token}`}
      });
    }
    return lastValueFrom(
      next.handle(request).pipe(
        catchError((err) => {

          if (err.status === 498) {
            // Token scaduto → tenta refresh
            return this.handle498(request, next);
          }

          if (err.status === 401) {
            // Token invalido/mancante → logout
            this._dialog.closeAll();
            this._auth.logout();
            return throwError(() => err);
          }

          console.error('[Token Interceptor]');
          console.error(err);

          return throwError(() => err);
        })));

  }

  private handle498(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this._auth.refreshAccessToken().pipe(
      // Solo il rinnovo fallito porta al logout, non un errore della richiesta ripetuta.
      catchError((err) => {
        this._dialog.closeAll();
        this._auth.logout();
        return throwError(() => err);
      }),
      // Ripete la request originale con il nuovo token
      switchMap((token) => next.handle(request.clone({
        setHeaders: {Authorization: `Bearer ${token}`}
      }))),
    );
  }

  private isSkipRoute(url: string): boolean {
    return this.SKIP_ROUTES.some(route => url.includes(route));
  }
}
